import Sniffr from 'sniffr';

var sniffr = new Sniffr();
sniffr.sniff();

export { sniffr as default };
